"use client";

import { c as _c } from "react/compiler-runtime";
import { BillingAddressForm } from "@/components/deals/contract/BillingAddressForm";
import { ContractPreview } from "@/components/deals/contract/ContractPreview";
import { BillingAddressCard } from "@/components/deals/shared/BillingAddressCard";
import type { DealContractReview } from "@/lib/deals/contract-review";
interface ContractReviewStepProps {
  dealId: string;
  role: "seller" | "buyer";
  contractReview: DealContractReview | null;
  onUpdateBilling: (values: {
    company?: string;
    name: string;
    addressLine1: string;
    addressLine2?: string;
    postalCode: string;
    city: string;
    country: string;
    taxId?: string;
  }) => Promise<void>;
  disabled?: boolean;
  className?: string;
}

/**
 * ContractReviewStep - Contract review step component
 *
 * Shows a read-only address summary + contract preview.
 * Falls back to BillingAddressForm if address was not yet collected.
 */
export function ContractReviewStep(t0) {
  const $ = _c(17);
  const {
    dealId,
    role,
    contractReview,
    onUpdateBilling,
    disabled: t1,
    className: t2
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const className = t2 === undefined ? "" : t2;
  const prefix = role === "seller" ? "seller" : "buyer";
  let t3;
  if ($[0] !== contractReview || $[1] !== prefix) {
    t3 = contractReview ? {
      company: contractReview[`${prefix}_billing_company` as keyof DealContractReview] as string | null,
      name: contractReview[`${prefix}_billing_name` as keyof DealContractReview] as string | null,
      addressLine1: contractReview[`${prefix}_billing_address_line1` as keyof DealContractReview] as string | null,
      addressLine2: contractReview[`${prefix}_billing_address_line2` as keyof DealContractReview] as string | null,
      postalCode: contractReview[`${prefix}_billing_postal_code` as keyof DealContractReview] as string | null,
      city: contractReview[`${prefix}_billing_city` as keyof DealContractReview] as string | null,
      country: contractReview[`${prefix}_billing_country` as keyof DealContractReview] as string | null,
      taxId: contractReview[`${prefix}_billing_tax_id` as keyof DealContractReview] as string | null
    } : undefined;
    $[0] = contractReview;
    $[1] = prefix;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const billingValues = t3;
  const hasAddress = !!billingValues?.name;
  const t4 = `space-y-6 ${className}`;
  let t5;
  if ($[3] !== billingValues || $[4] !== disabled || $[5] !== hasAddress || $[6] !== onUpdateBilling || $[7] !== role) {
    t5 = hasAddress ? <BillingAddressCard address={billingValues} label={role === "seller" ? "Verk\xE4ufer" : "K\xE4ufer"} role={role} variant="card" /> : <BillingAddressForm role={role} initialValues={billingValues} onSubmit={onUpdateBilling} disabled={disabled} />;
    $[3] = billingValues;
    $[4] = disabled;
    $[5] = hasAddress;
    $[6] = onUpdateBilling;
    $[7] = role;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = contractReview?.contract_document_url ?? contractReview?.contract_preview_url;
  const t7 = contractReview?.contract_uploaded_at ?? contractReview?.contract_preview_generated_at;
  let t8;
  if ($[9] !== dealId || $[10] !== t6 || $[11] !== t7) {
    t8 = <ContractPreview dealId={dealId} previewUrl={t6} generatedAt={t7} />;
    $[9] = dealId;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t8) {
    t9 = <div className={t4}>{t5}{t8}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}